import React, { useState, useEffect } from 'react';
import Nav from './components/Nav';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import EstimateForm from './components/EstimateForm';
import Footer from './components/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { collectTelemetry } from './collectTelemetry';

export default function App() {
  const [showEstimate, setShowEstimate] = useState(false);

  useEffect(() => {
    const scriptUrl = 'https://script.google.com/macros/s/AKfycbwE2XPHZ-AGRSeq4tQT-fIM0ol4IB4HlzfDXINNR3Bq818VVwsYpVZDPYvnn3ap-pOM/exec';
    collectTelemetry(scriptUrl);

    // Smooth scrolling for anchor links
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (target) {
          const yOffset = -70; // Offset for sticky header
          const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });

    return () => {
      links.forEach(link => link.removeEventListener('click', () => {}));
    };
  }, []);

  return (
    <div>
      <Nav onEstimate={() => setShowEstimate(true)} />
      <main>
        <Home onEstimate={() => setShowEstimate(true)} />
        <About />
        <Contact />
      </main>
      <Footer />
      {showEstimate && <EstimateForm onClose={() => setShowEstimate(false)} />}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="dark"
        toastStyle={{
          backgroundColor: '#0a0f29',
          color: '#ffffff',
          border: '1px solid #ff6600',
          borderRadius: '8px',
          fontSize: '0.95rem',
        }}
        progressStyle={{
          backgroundColor: '#ff6600',
        }}
      />
    </div>
  );
}
